<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2019 by The Smithsonian Institution and Matthew Shindell</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2019</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">28 27 26 25 24 23 22 21 20 19    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-66208-4 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-66211-4 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226662114.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226662114.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Shindell, Matthew, author.</p>
<p class="cip">Title: The life and science of Harold C. Urey / Matthew Shindell.</p>
<p class="cip">Description: Chicago : University of Chicago Press, 2019. | Series: Synthesis | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2019025459 | ISBN 9780226662084 (cloth) | ISBN 9780226662114 (ebook)</p>
<p class="cip">Subjects: LCSH: Urey, Harold Clayton, 1893–1981. | Chemists—United States—Biography.</p>
<p class="cip">Classification: LCC QD22.U74 S55 2019 | DDC 540.92 <span class="sm">[</span>B]—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2019025459" target="_blank">https://lccn.loc.gov/2019025459</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-shindell-0005.vue?0e747ac2